var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7586 24.9323C22.0325 24.9323 23.0652 23.8997 23.0652 22.6258C23.0652 21.4023 22.5791 20.229 21.714 19.3638C20.8489 18.4987 19.6755 18.0127 18.4521 18.0127H9.22589C8.00242 18.0127 6.82906 18.4987 5.96394 19.3638C5.09881 20.229 4.61279 21.4023 4.61279 22.6258",
    fill: "#CAD3E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0652 22.6258V22.6258C23.0652 23.8997 22.0325 24.9323 20.7586 24.9323H6.91934C5.64547 24.9323 4.61279 23.8997 4.61279 22.6258V22.6258C4.61279 21.4023 5.09881 20.229 5.96394 19.3638C6.82906 18.4987 8.00242 18.0127 9.22589 18.0127H18.4521C19.6755 18.0127 20.8489 18.4987 21.714 19.3638C22.5792 20.229 23.0652 21.4023 23.0652 22.6258Z",
    stroke: "black",
    strokeWidth: 2.76786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8392 13.399C16.3869 13.399 18.4523 11.3337 18.4523 8.78595C18.4523 6.2382 16.3869 4.17285 13.8392 4.17285C11.2914 4.17285 9.22607 6.2382 9.22607 8.78595C9.22607 11.3337 11.2914 13.399 13.8392 13.399Z",
    fill: "#CAD3E6",
    stroke: "black",
    strokeWidth: 2.76786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.32139f6a8403e33f400dafb223a60115.svg";
export { ForwardRef as ReactComponent };